import { Section, SectionHeading, FadeIn } from "@/components/Section";
import { Check, Sparkles } from "lucide-react";

const FILTERS = [
  "Strong consumer demand",
  "Repeat utilization potential",
  "Recurring revenue compatibility",
  "Vendor reliability",
  "Operational simplicity",
  "Clinic margin potential",
  "Compliance viability",
  "Scalability across clinic types",
];

export default function CurationLogic() {
  return (
    <Section testId="curation-section" className="bg-slate-900 text-white relative overflow-hidden">
      <span className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-blue-500/20 blur-3xl pointer-events-none" />
      <span className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-indigo-500/10 blur-3xl pointer-events-none" />

      <div className="relative grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-300 mb-4">How we curate</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
            Only the most relevant, high-performing services make it into the platform.
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed max-w-xl">
            We don't ship everything — we ship what works. Our moat is the discipline of what we exclude.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/10 px-4 py-2 text-xs font-medium text-slate-200 backdrop-blur">
            <Sparkles className="w-3.5 h-3.5 text-blue-300" />
            A curated shortlist — not a marketplace
          </div>
        </div>

        <div className="lg:col-span-6">
          <FadeIn>
            <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-6 lg:p-8">
              <div className="text-[11px] uppercase tracking-[0.18em] font-semibold text-blue-300">Selection criteria</div>
              <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {FILTERS.map((f, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-2.5 rounded-xl border border-white/10 bg-white/5 px-3.5 py-3"
                  >
                    <span className="w-5 h-5 rounded-md bg-emerald-500/20 text-emerald-300 flex items-center justify-center shrink-0 mt-0.5">
                      <Check className="w-3 h-3" />
                    </span>
                    <span className="text-sm text-slate-100">{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>
  );
}
